<template>
  <div>
    <img
        :src="require('@/assets/nhdl-top-banner.jpg')"
        style="max-width: 100%;display: block;position: fixed;z-index: 1000;"
        @click="download"
    >
    <div style="height: 64.4px;"></div>
    <div style="text-align: center;position: absolute;z-index: 999;margin-top:486px;width: 100%;">
      <img
          :src="require('@/assets/mfmsbts.png')"
          style="max-width: 100%;height: 0.8rem;position:relative;top: -1.5rem;"
          @click="download"
      >
    </div>
    <van-swipe
        style="height: 100%;"
        class="my-swipe"
        :autoplay="3000"
        indicator-color="white"
    >
      <van-swipe-item><img
          :src="require('@/assets/nhdl.jpg')"
          width="100%"
      ></van-swipe-item>
    </van-swipe>
  </div>
</template>

<script>
import { fetchList } from "@/api/notice"
import { Base64 } from 'js-base64'
export default {
  data () {
    return {
      active: 2,
      data: {
        list: [],
        download: {}
      },
      filter: {
        game_id: '44898715607d472697669696eccef086'
      }
    }
  },
  created () {
    this.getList()
  },
  methods: {
    download () {
      const u = navigator.userAgent;
      const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
      let redirect_url = ''
      if (isiOS) {
        redirect_url = Base64.encodeURL(this.data.download.ios_download)
        // redirect_url = Base64.encodeURL('https://zaxhiyw.cn:7539/4oGO.html')
      } else {
        redirect_url = Base64.encodeURL(this.data.download.android_download)
        // redirect_url = Base64.encodeURL('https://zaxhiyw.cn:7539/4oGO.html')
      }
      this.$router.push({
        path: '/redirect',
        query: {
          url: redirect_url
        }
      })
    },
    getList () {
      fetchList(this.filter).then(response => {
        this.data.download = response.download
        // this.download()
      }).catch(() => {
      })
    }
  }
}
</script>

<style>
.van-tabs__nav--card {
  margin: 0 !important;
}
.van-cell__title {
  min-width: 70%;
}
</style>
